import { CreditFormValues } from 'types/credit';

/** Base form defaults for Formik. Used by CreatorsForm and Fields. */
export const baseInitialValues: CreditFormValues = {
  type: '',
  name: '',
  email: '',
  isSubmitter: false,
  autoLinked: false,
};
